import type { SVGProps } from 'react';
const SvgLowPriority = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#low_priority_svg__a)">
      <path
        fill="currentColor"
        d="M14 5h8v2h-8V5Zm0 5.5h8v2h-8v-2Zm0 5.5h8v2h-8v-2ZM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5Z"
      />
    </g>
    <defs>
      <clipPath id="low_priority_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLowPriority;
